import React from "react";
import "../landing.css";
import styled from "styled-components";
import right from "@asset/ces/ces-icon-arrow-right.png";
import { useNavigate } from "react-router-dom";

const RightIcon = styled.img`
  width: 36px;
  height: 36px;
`;

const BookHereButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/ces/reservation");
  };

  return (
    <div className="btn_book_here" onClick={handleClick}>
      <p className="btn_book_here_text">Book Here</p>
      <RightIcon src={right} alt="right_icon" />
    </div>
  );
};

export default BookHereButton;
